import { render, staticRenderFns } from "./form-presentation-layout.vue?vue&type=template&id=6397cabb&scoped=true&"
import script from "./form-presentation-layout.vue?vue&type=script&lang=ts&"
export * from "./form-presentation-layout.vue?vue&type=script&lang=ts&"
import style0 from "./form-presentation-layout.vue?vue&type=style&index=0&id=6397cabb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6397cabb",
  null
  
)

export default component.exports